import { call, put, all, takeLatest, delay } from 'redux-saga/effects';

import { apiTransacao } from '~/services/api';

import { successTransacoes, failureTransacoes } from './actions';

function* requestTransacoes(payload) {
	const params = payload.payload;
	yield delay(3000);
	try {
		const { data } = yield call(
			apiTransacao.post,
			`transacoes_cliente/`,
			params
		);
		yield put(successTransacoes(data));
	} catch (error) {
		yield put(failureTransacoes(error.response.status));
	}
}

export default all([
	takeLatest('@clientTransacoes/REQUEST', requestTransacoes),
]);
